import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RaterList from "../Components/User/RaterList";
import { userService } from "../Services/UserService.js";
import { languageService } from "../Services/LanguageService.js";
import { withRouter } from 'react-router';
import * as languageActions from '../Actions/languageActions';
import * as customerActions from '../Actions/customerActions';
import * as supplierConfigurationActions from '../Actions/supplierConfigurationActions';
import { languagePairSchema, userSchema, customerSchema, customerListSchema } from '../Schemas/OrderSchema.js';
import { customerService } from "../Services/CustomerService.js";
import { normalize } from 'normalizr';

class RaterListContainer extends Component {
	constructor(props){
		super(props);
		this.state={
			raters: null
		}
		this.updateRaters = this.updateRaters.bind(this);
		this.parseRaters = this.parseRaters.bind(this);
		this.parseLanguages = this.parseLanguages.bind(this);
		this.getRaters = this.getRaters.bind(this);
		this.SetLanguagesToUsers = this.SetLanguagesToUsers.bind(this);
		this.fetchCustomerRecords = this.fetchCustomerRecords.bind(this);
		this.handleMorePriority = this.handleMorePriority.bind(this);
		//this.addRater = this.addRater.bind(this);
	}
	
	componentDidMount() {
		userService.getRaters()
					.then(response => {return this.parseRaters(response.data)})
					.then(response => {languageService.getLangiuagePairs().then(response => {return this.parseLanguages(response.data)}).then(response => {return customerService.listCustomers(this.props.user.access_token).then(response => {return this.fetchCustomerRecords(response.data);});}); })
					.catch(err => {/*console.log(err);*/});
	}
		
	fetchCustomerRecords(responseData){
		var normalizedData = normalize(responseData, customerListSchema);
		this.props.actions.fetchCustomerRecords(normalizedData.entities.customers);
		this.props.actions.fetchSupplierConfigurationRecords(normalizedData.entities.supplierConfiguration);
		return 1;
	}
	
	parseRaters(raters){
		let lp = new Object();
		for(let i=0; i<raters.length; i++){
			if(typeof(lp[raters[i].languagePair.id])!=="undefined"){
				lp[raters[i].languagePair.id].push({	id: raters[i].id,
														user: raters[i].user});
			}else{
				var lst=[];
				lst.push({	id: raters[i].id,
							user: raters[i].user});
				lp[raters[i].languagePair.id]=lst;
			}
		}
		this.setState({raters: lp});
		return 1;
	}
	
	parseLanguages(languages){
		var normalizedData = normalize(languages, [languagePairSchema]);
		this.props.actions.fetchLanguagePairs(normalizedData.entities.languagePairs);
		return 1;
	}
	
	handleMorePriority(raterId){
		userService.raterMorePriority(raterId)
					.then(response => userService.getRaters()
					.then(response => {return this.parseRaters(response.data)})
					.then(response => {languageService.getLangiuagePairs().then(response => {return this.parseLanguages(response.data)}).then(response => {return customerService.listCustomers(this.props.user.access_token).then(response => {return this.fetchCustomerRecords(response.data);});}); })
					)
					.catch(err => {/*console.log(err);*/});
	}
	
	//handleMorePriority(idProd, index, idUsr){
	//	if(index>0){
	//		let suppliers = this.props.customer.product.find(prod => {if(prod.id == idProd){return true;}}).suppliers;
	//		let enabled = suppliers.filter( s => this.props.userRecords[s].enabled );
	//		let disabled = suppliers.filter( s => !this.props.userRecords[s].enabled );
	//		let users=[];
	//		for(let i=0; i<enabled.length; i++){
	//			if(i==(index-1)){
	//				users.push(enabled[index]);
	//				users.push(enabled[i]);
	//				i++;
	//			}else{
	//				users.push(enabled[i]);
	//			}
	//		}
	//		users.push(...disabled);
	//		customerService.updateSupplierList(this.props.customer.id, idProd, users)
	//				.then(response => {return customerService.listCustomers()})
	//				.then(response => {return this.fetchCustomerRecords(response.data);})
	//				.catch(err => {/*console.log(err);*/});
	//	}
	//}
	
	updateRaters(pairId, canvis){
//		console.log("updateRaters");
//		console.log(canvis);
		for (var [key, value] of Object.entries(canvis)){
			if(value>0){
				userService.deleteRater(value).then(() => this.getRaters());
			}else if(value===0){
				userService.addRater(pairId, key).then(() => this.getRaters());
			}
		}
	}
	
	getRaters(){
		userService.getRaters()
					.then(response => {return this.parseRaters(response.data); })
					.then(() => {this.setState({dialogOpen: false}); return 1;})
					.catch(err => {/*console.log(err);*/});
		return 1;
	}
	
	SetLanguagesToUsers(){
		let users = new Object();
		for (const [user_id, user] of Object.entries(this.props.userRecords)){
			if(user.username.length>1 && user.role=="TRANSLATOR"){
				users[user_id]=user;
			}
		}
		for (const [customer_id, customer] of Object.entries(this.props.customerRecords)) {
			customer.product.forEach(product => {
										if(product.task == 'translation'){
											product.suppliers.forEach( configuration => {
												if(typeof this.props.supplierConfigRecords[configuration] !== 'undefined'){
													let supplier = this.props.supplierConfigRecords[configuration].supplier
													if(users[supplier] && users[supplier].enabled){
														if(!users[supplier].hasOwnProperty('lp')){
															users[supplier].lp=new Array();
														}
														if(!users[supplier].lp.includes(product.langPair)){
															users[supplier].lp.push(product.langPair);
														}
													}
												}
											})
										}
									})
		}
		return users;
	}
	
	//addRater(){
	//	userService.addRater(userId, langPairId)
	//		.then(() => userService.getRaters())
	//		.then(response => {return this.setState({raters: response.data});})
	//		.catch(err => {/*console.log(err);*/});
	//}
	
	render() {
		//console.log("RaterListContainer:");
		//console.log(this.props);
		//console.log(this.state);
		if(this.state.raters==null){
			return <div>PROCESSING...</div>
		}else{
			return (<RaterList	raters={this.state.raters}
								//users={this.props.userRecords}
								users={this.SetLanguagesToUsers()}
								langPairs={this.props.langPairs}
								updateRaters={this.updateRaters}
								handleMorePriority={this.handleMorePriority}/>);
		}
	}
}

function mapStateToProps(state, ownProps) {  
	return {customerRecords: state.customers, supplierConfigRecords: state.supplierConfiguration, userRecords: state.users, langPairs: state.languagePairs, user: state.user}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(Object.assign({}, customerActions, supplierConfigurationActions, languageActions), dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(RaterListContainer);  